import * as Styled from './row-based-layout.styled'
import {SignOutButton} from '../../actions/sign-out-button'
import {GetHelpButton} from '../../actions/get-help-button'
import * as ErrorStyles from '../../error.styled'
import {RowBasedLoginLayout} from './row-based-login-layout'

import type {JSX} from 'react'

export function ErrorPanel(): JSX.Element {
    return (
        <RowBasedLoginLayout>
            <Styled.MainActionsGrid>
                <div>
                    <ErrorStyles.Title>Error</ErrorStyles.Title>
                    <ErrorStyles.Message>
                        We&#39;re sorry we can&#39;t log you in
                    </ErrorStyles.Message>
                </div>
                <SignOutButton buttonText="Continue" />
                <GetHelpButton smallText={true} />
            </Styled.MainActionsGrid>
        </RowBasedLoginLayout>
    )
}
